import React, { useEffect, useState } from "react";
import DataTable, { SortOrder } from "react-data-table-component";
import { http } from "../helper";
import { BaseUrl } from "../common/config";
import DatePicker from "react-datepicker";
import { format } from "date-fns";
import Popup from "../common/popup";
import { useTranslation } from "react-i18next";

export const PriceBandReport = ({}) => {
  const { t } = useTranslation();

  const priceFormat = (price) => {
    return price.toLocaleString("en-US", {
      style: "currency",
      currency: "GBP",
      minimumFractionDigits: 2,
    });
  };

  const viewCustomers = (priceBand) => {
    setLoading(true);
    let payload = { priceBand: priceBand };
    let URL2 = BaseUrl + "admin/getaccountsbasedonpricelist";
    http
      .post(URL2, payload)
      .then((response) => {
        setLoading(false);
        const actualMonth = parseInt(months);
        const updatedAccounts = response.data.data
          .map((account) => {
            const existsInOrders =
              filter === "monthly"
                ? ordersbyAccountCode.some(
                    (order) =>
                      order._id.accountCode === account.accountCode &&
                      order._id.month === actualMonth,
                  )
                : filter === "quarterly"
                  ? ordersbyAccountCode.some(
                      (order) =>
                        order._id.accountCode === account.accountCode &&
                        order._id.quarter === quarter,
                    )
                  : filter === "yearly"
                    ? ordersbyAccountCode.some(
                        (order) =>
                          order._id.accountCode === account.accountCode,
                      )
                    : ordersbyAccountCode.some(
                        (order) => order._id === account.accountCode,
                      );
            return { ...account, ordered: existsInOrders };
          })
          .filter((account) => account.accountStatus === "active");
        setAccountPriceBand(priceBand);
        setPriceBandAccounts(updatedAccounts);
        setPopupView(true);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  const viewOrderedCustomers = (priceBand) => {
    setLoading(true);
    let payload = { priceBand: priceBand };
    let URL2 = BaseUrl + "admin/getaccountsbasedonpricelist";
    http
      .post(URL2, payload)
      .then((response) => {
        setLoading(false);
        const actualMonth = parseInt(months);
        const updatedAccounts = response.data.data
          .map((account) => {
            const existsInOrders =
              filter === "monthly"
                ? ordersbyAccountCode.some(
                    (order) =>
                      order._id.accountCode === account.accountCode &&
                      order._id.month === actualMonth,
                  )
                : filter === "quarterly"
                  ? ordersbyAccountCode.some(
                      (order) =>
                        order._id.accountCode === account.accountCode &&
                        order._id.quarter === quarter,
                    )
                  : filter === "yearly"
                    ? ordersbyAccountCode.some(
                        (order) =>
                          order._id.accountCode === account.accountCode,
                      )
                    : ordersbyAccountCode.some(
                        (order) => order._id === account.accountCode,
                      );
            return { ...account, ordered: existsInOrders };
          })
          .filter((account) => account.ordered);
        setAccountPriceBand(priceBand);
        setOrderedAccounts(updatedAccounts);
        setorderedPopupView(true);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  const columns = [
    {
      name: t("price_band_txt"),
      selector: (row) =>
        typeof row._id === "object" ? `${row._id.priceBand}` : row._id,
      sortable: false,
    },
    {
      name: t("no_of_orders_txt"),
      selector: (row) => (row.orderCount > 0 ? row.orderCount : "-"),
      sortable: true,
    },
    {
      name: t("ordered_amount_txt"),
      selector: (row) => (row.sum > 0 ? priceFormat(row.sum) : "-"),
      sortable: true,
      sortFunction: (a, b) => {
        const totalA = parseFloat(a.sum) || 0;
        const totalB = parseFloat(b.sum) || 0;
        return totalA - totalB;
      },
    },
    {
      name: t("avg_spent_txt"),
      selector: (row) =>
        row.sum > 0 && row.orderCount > 0
          ? priceFormat(row.sum / row.orderCount)
          : "-",
      sortable: true,
      sortFunction: (a, b) => {
        const avgA = parseFloat(a.sum / a.orderCount);
        const avgB = parseFloat(b.sum / b.orderCount);
        return avgA - avgB;
      },
    },
    {
      name: t("ordered_customers_txt"),
      selector: (row) => (
        <a
          className="title-tooltip title-up button btn-sl"
          data-title={t("view_customers_txt")}
          style={{
            color: "white",
            cursor: row.sum > 0 ? "pointer" : "not-allowed",
          }}
          onClick={
            row.sum > 0
              ? () =>
                  viewOrderedCustomers(
                    typeof row._id === "object" ? row._id.priceBand : row._id,
                  )
              : undefined
          }
        >
          {row.accountCount}
        </a>
      ),
      sortable: false,
    },
    {
      name: t("no_of_active_customers_txt"),
      selector: (row) => {
        const count = getCountByPriceBand(
          typeof row._id === "object" ? row._id.priceBand : row._id,
        );
        return (
          <a
            className="title-tooltip title-up button"
            data-title={t("view_customers_txt")}
            style={{
              color: "white",
              cursor: count > 0 ? "pointer" : "not-allowed",
            }}
            onClick={
              count > 0
                ? () =>
                    viewCustomers(
                      typeof row._id === "object" ? row._id.priceBand : row._id,
                    )
                : undefined
            }
          >
            {`${count} ${t("customers_txt")}`}
          </a>
        );
      },
    },
  ];

  const customStyles = {
    rows: {
      style: {
        minHeight: "25px",
      },
    },
    headCells: {
      style: {
        padding: "8px", // override the cell padding for head cells
      },
    },
    cells: {
      style: {
        padding: "8px", // override the cell padding for data cells
      },
    },
  };

  const paginationComponentOptions = {
    rowsPerPageText: "",
    rangeSeparatorText: "",
    selectAllRowsItem: true,
    selectAllRowsItemText: "",
    noRowsPerPage: "",
  };

  var currentTime = new Date();
  var currentyear = currentTime.getFullYear();
  var currentMonth = currentTime.getUTCMonth() + 1;
  const [filter, setFilter] = useState(0);
  const [filtertext, setFilterText] = useState("");
  const [topOrderedCustomers, setTopOrderedCustomers] = useState([]);
  const [priceBandAccounts, setPriceBandAccounts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [accountCounts, setAccountCounts] = useState([]);
  const [popupView, setPopupView] = useState(false);
  const [orderedpopupView, setorderedPopupView] = useState(false);
  const [loading, setLoading] = useState(false);
  const [ordersbyAccountCode, setOrdersbyAccountCode] = useState([]);
  const [accountPriceband, setAccountPriceBand] = useState([]);
  const [orderedAccounts, setOrderedAccounts] = useState([]);
  const getCurrentFiscalYear = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth() + 1;
    // Fiscal year starts in September
    const startYear = month >= 9 ? year : year - 1;
    const endYear = startYear + 1;
    return `${startYear}-${endYear}`;
  };
  const [period, setPeriod] = useState(getCurrentFiscalYear());
  const [months, setMonths] = useState("9");
  const [quarter, setQuarter] = useState("");
  const MonthNames = [
    t("months.sep"),
    t("months.oct"),
    t("months.nov"),
    t("months.dec"),
    t("months.jan"),
    t("months.feb"),
    t("months.mar"),
    t("months.apr"),
    t("months.may"),
    t("months.jun"),
    t("months.jul"),
    t("months.aug"),
  ];
  const currentFiscalMonth = new Date().getMonth(); // 0-indexed: Jan = 0, Apr = 3, Sep = 8

  const quarterNames = {
    1: t("quarter_sep_nov"),
    2: t("quarter_dec_feb"),
    3: t("quarter_mar_may"),
    4: t("quarter_jun_aug"),
  };

  const getCurrentFiscalQuarter = () => {
    const month = new Date().getMonth() + 1; // 1–12
    if (month >= 9 && month <= 11) return 1; // Sep–Nov
    if (month === 12 || month <= 2) return 2; // Dec–Feb
    if (month >= 3 && month <= 5) return 3; // Mar–May
    return 4; // Jun–Aug
  };

  const getAvailableQuarters = (selectedFiscalYear) => {
    const currentFiscalYear = getCurrentFiscalYear();
    const currentQuarter = getCurrentFiscalQuarter();
    return Object.entries(quarterNames)
      .filter(([quarterNumber]) => {
        if (selectedFiscalYear === currentFiscalYear) {
          return Number(quarterNumber) <= currentQuarter;
        }
        return true; // show all for past years
      })
      .map(([quarterNumber, label]) => (
        <option key={quarterNumber} value={quarterNumber}>
          {label}
        </option>
      ));
  };

  useEffect(() => {
    const now = new Date();
    const month = now.getMonth() + 1;
    const fiscalQuarterMap = {
      9: 1,
      10: 1,
      11: 1,
      12: 2,
      1: 2,
      2: 2,
      3: 3,
      4: 3,
      5: 3,
      6: 4,
      7: 4,
      8: 4,
    };
    const currentFiscalQuarter = fiscalQuarterMap[month];
    setQuarter(currentFiscalQuarter);
  }, []);

  const getCountByPriceBand = (priceBand) => {
    const account = accountCounts.find((account) => account._id === priceBand);
    return account ? account.count : 0;
  };

  useEffect(() => {
    setIsLoading(true);
    let URL2 = BaseUrl + "admin/getaccountcount";
    http
      .post(URL2)
      .then((response) => {
        setIsLoading(false);
        setAccountCounts(response.data.data);
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      });
  }, []);

  useEffect(() => {
    setIsLoading(true);
    if (filter === "custom" && (!fromDate || !toDate)) {
      setIsLoading(false);
      // Don't make the API call if dates are missing for the "custom" filter
      return;
    }
    let payload = {};
    if (filter === "custom") {
      payload = {
        filter: filter,
        datefrom: format(new Date(fromDate), "yyyy-MM-dd"),
        dateto: format(new Date(toDate), "yyyy-MM-dd"),
      };
      setShowDatePicker(false);
    } else if (["weekly", "monthly", "quarterly", "yearly"].includes(filter)) {
      payload = {
        filter: filter,
        datefrom: "",
        dateto: "",
        period: period,
      };
    } else {
      payload = {
        filter: parseInt(filter),
        datefrom: "",
        dateto: "",
      };
    }
    let URL3 = BaseUrl + "admin/getordersgroupedbyaccountcode";
    http
      .post(URL3, payload)
      .then((response) => {
        setIsLoading(false);
        setOrdersbyAccountCode(response.data.data);
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      });
    let URL2 = BaseUrl + "admin/pricebandreport";
    http
      .post(URL2, payload)
      .then((response) => {
        setIsLoading(false);
        const actualMonth = parseInt(months);
        const updatedData1 =
          filter === "monthly"
            ? response.data.data.filter(
                (item) => item._id.month === actualMonth,
              )
            : filter === "quarterly"
              ? response.data.data.filter(
                  (item) => item._id.quarter === quarter,
                )
              : response.data.data;
        setTopOrderedCustomers(updatedData1);
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      });
  }, [filter, fromDate, toDate, months, quarter, period]);

  const changeFilterHandler = (e) => {
    setFilter(e.target.value);
    setFilterText(e.target.options[e.target.selectedIndex].text);
    if (e.target.value === "custom") {
      setShowDatePicker(true);
    } else {
      setShowDatePicker(false);
      setFromDate(null);
      setToDate(null);
      setFilter(e.target.value);
    }
  };

  const changePeriodHandler = (e) => {
    const newPeriod = e.target.value;
    setPeriod(newPeriod); // update selected fiscal year in state
    //split fiscal year
    const [newStartYear, newEndYear] = newPeriod.split("-").map(Number);
    const fiscalStartMonthIndex = 8; // 0-based index for September
    const today = new Date();
    const currentFiscalYear = getCurrentFiscalYear();
    //compare sleted year with currentfiscalyear
    const isCurrentFiscalYear = newPeriod === currentFiscalYear;
    // MONTHLY filter logic
    if (filter === "monthly") {
      let visibleMonthNames = MonthNames;
      if (isCurrentFiscalYear) {
        // Calculate current fiscal month index
        const currentMonthIndex = today.getMonth(); // 0-based
        const monthsPassedSinceFiscalStart =
          (currentMonthIndex - fiscalStartMonthIndex + 12) % 12;
        const maxVisibleIndex = monthsPassedSinceFiscalStart;
        visibleMonthNames = MonthNames.slice(0, maxVisibleIndex + 1);
      }
      const selectedMonthIndex = MonthNames.indexOf(months);
      const isValidMonth =
        selectedMonthIndex >= 0 &&
        selectedMonthIndex < visibleMonthNames.length;
      if (!isValidMonth) {
        const defaultMonthNumber = ((0 + fiscalStartMonthIndex) % 12) + 1;
        setMonths(String(defaultMonthNumber));
      }
    }
    // QUARTERLY filter logic
    if (filter === "quarterly") {
      const currentQuarter = getCurrentFiscalQuarter();
      let maxQuarter = 4;
      if (isCurrentFiscalYear) {
        maxQuarter = currentQuarter;
      }
      if (parseInt(quarter) > maxQuarter) {
        setQuarter(maxQuarter > 0 ? String(maxQuarter) : "1");
      }
    }
  };

  const changeMonthHandler = (e) => {
    setMonths(e.target.value);
  };

  const formatDate = (dateString) => {
    const dateObject = new Date(dateString);
    const year = dateObject.getFullYear();
    const month = String(dateObject.getMonth() + 1).padStart(2, "0");
    const day = String(dateObject.getDate()).padStart(2, "0");
    return `${day}/${month}/${year}`;
  };

  const DateChange = (value, type) => {
    if (type === "from") {
      setFromDate(value);
      if (toDate && value && value > toDate) {
        setToDate(null);
      }
    } else if (type === "to") {
      if (!fromDate || value >= fromDate) {
        setToDate(value);
      } else {
        // Handle invalid date selection
        setToDate(null);
      }
    }
  };
  // Calculate dynamic pagination options
  const calculatePaginationOptions = (totalRecords, interval) => {
    const options = [];
    for (let i = interval; i <= totalRecords; i += interval) {
      options.push(i);
    }
    return options;
  };

  const totalRecords = topOrderedCustomers.length; // Get the total records count
  const paginationOptions = calculatePaginationOptions(totalRecords, 10); // Generate options with interval of 10
  const options = [];
  for (let i = currentyear; i >= 2023; i--) {
    if (i === currentyear && currentMonth < 9) {
      continue;
    }
    const year = i;
    options.push(
      <option value={year + "-" + (year + 1)}>
        {year + "-" + (year + 1)}
      </option>,
    );
  }

  const currentFiscalYear = getCurrentFiscalYear();
  let visibleMonthNames = MonthNames;
  if (period === currentFiscalYear) {
    // Limit to current fiscal month
    const fiscalIndex = (new Date().getMonth() - 8 + 12) % 12; // Sep=0, Oct=1, ... Aug=11
    visibleMonthNames = MonthNames.slice(0, fiscalIndex + 1);
  }

  let loadingbuffer = isLoading ? "loading-buffer" : "";

  return (
    <div
      className={`chart-container chart-high-priceband ${loadingbuffer}`}
      style={{ verticalAlign: "top" }}
    >
      <div className="chart-Hdr">
        <div className="chart-Hdr-txt">
          <h2>{t("high_value_pricebands_txt")}</h2>
        </div>
        <div
          className="chart-fltr"
          onMouseEnter={() => {
            if (filter === "custom" && !showDatePicker) {
              setShowDatePicker(true);
            }
          }}
          onMouseLeave={() => {
            if (filter === "custom" && showDatePicker) {
              setShowDatePicker(false);
            }
          }}
        >
          {
            <select value={filter} onChange={(e) => changeFilterHandler(e)}>
              <option value={0}>{t("all_txt")}</option>
              <option value={"weekly"}>{t("current_week_txt")}</option>
              <option value={"monthly"}>{t("monthly_txt")}</option>
              <option value={"quarterly"}>{t("quarterly_txt")}</option>
              <option value={"yearly"}>{t("fy_data_txt")}</option>
              <option value={30}>{t("past_30_days_txt")}</option>
              <option value={90}>{t("past_90_days_txt")}</option>
              <option value={180}>{t("past_180_days_txt")}</option>
              <option value={365}>{t("past_1_year_txt")}</option>
              <option value={"custom"}>{t("custom_date_txt")}</option>
            </select>
          }
          {showDatePicker && (
            <div className="date-picker-container">
              <label>{t("from_label_txt")}</label>
              <DatePicker
                selected={fromDate}
                onChange={(date) => DateChange(date, "from")}
                showDisabledMonthNavigation
                dateFormat="dd/MM/yyyy"
                disablePast={true}
                maxDate={new Date()}
                placeholderText={t("select_date_txt")}
              />
              <label>{t("to_label_txt")}</label>
              <DatePicker
                selected={toDate}
                showDisabledMonthNavigation
                dateFormat="dd/MM/yyyy"
                onChange={(date) => DateChange(date, "to")}
                disablePast={true}
                maxDate={new Date()}
                placeholderText={t("select_date_txt")}
              />
            </div>
          )}
          {filter === "quarterly" && (
            <select
              style={{ width: "160px" }}
              value={quarter}
              onChange={(e) => setQuarter(Number(e.target.value))}
            >
              {getAvailableQuarters(period)}
            </select>
          )}
          {filter === "monthly" && (
            <select
              style={{ width: "50px" }}
              value={months}
              onChange={(e) => changeMonthHandler(e)}
            >
              {visibleMonthNames.map((monthName, index) => {
                const monthNumber = ((index + 8) % 12) + 1; // fiscal-to-calendar month number
                return (
                  <option key={monthNumber} value={monthNumber}>
                    {monthName}
                  </option>
                );
              })}
            </select>
          )}
          {(filter === "monthly" ||
            filter === "quarterly" ||
            filter === "yearly") && (
            <select
              style={{ width: "170px" }}
              value={period}
              onChange={(e) => changePeriodHandler(e)}
            >
              {options}
            </select>
          )}
        </div>
        <div className="fltr-sub-val">
          {topOrderedCustomers.length > 0 && (
            <span className="fltr-val">
              {t("total_records_txt")}:{" "}
              <strong>{topOrderedCustomers.length}</strong>{" "}
              {[
                t("current_week_txt"),
                t("monthly_txt"),
                t("quarterly_txt"),
                t("fy_data_txt"),
              ].includes(filtertext)
                ? ""
                : filtertext != "" && filtertext != t("custom_date_txt")
                  ? " (" + filtertext + ")"
                  : filtertext === t("custom_date_txt") && fromDate && toDate
                    ? " (" +
                      formatDate(fromDate) +
                      " - " +
                      formatDate(toDate) +
                      ")"
                    : " (" + t("all_txt") + ")"}
            </span>
          )}
        </div>
      </div>
      <DataTable
        columns={columns}
        data={topOrderedCustomers}
        customStyles={customStyles}
        noDataComponent={
          <div className="no-records-found">
            {t("no_data_filtered_search_txt")}
          </div>
        }
        pagination
        paginationPerPage={10}
        paginationRowsPerPageOptions={[10, 20, 40, 60, 80, 100]}
        paginationComponentOptions={paginationComponentOptions}
      />
      {popupView && (
        <Popup
          extClass="order-pop priceBand-cart-details-pop"
          headMoreTxt={
            <>
              <div className="order-top"></div>{" "}
            </>
          }
          closebtn={
            <>
              <div className="pop-header-top order-top">
                <div className="head">
                  <h4>
                    {accountPriceband} - {t("customers_txt")}
                  </h4>
                </div>
                <span
                  onClick={() => setPopupView(false)}
                  className="close"
                ></span>
              </div>
            </>
          }
          bodyMoreTxt={
            <>
              <div className="modal-table">
                {loading && (
                  <div className="loading-overlay">
                    <div className="loading-message">{t("loading_txt")}</div>
                  </div>
                )}
                {!loading && (
                  <div className="checkout-table">
                    <div className="table_overflow">
                      <table>
                        <thead>
                          <tr>
                            <td align="left">{t("account_code_txt")}</td>
                            <td align="left">{t("account_name_txt")}</td>
                            <td align="center">{t("ordered_txt")}</td>
                          </tr>
                        </thead>
                        <tbody>
                          {priceBandAccounts.length > 0 &&
                            priceBandAccounts
                              .sort((a, b) => b.ordered - a.ordered)
                              .map((item, index) => {
                                return (
                                  <tr key={index}>
                                    <td>{item.accountCode}</td>
                                    <td align="left">{item.accountName}</td>
                                    <td align="center">
                                      {item.ordered ? (
                                        <span className="price-ord-yes">
                                          <i
                                            className="fa fa-check"
                                            aria-hidden="true"
                                          ></i>
                                        </span>
                                      ) : (
                                        <span className="price-ord-no">
                                          <i
                                            className="fa fa-times"
                                            aria-hidden="true"
                                          ></i>
                                        </span>
                                      )}
                                    </td>
                                  </tr>
                                );
                              })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}
              </div>
            </>
          }
        />
      )}
      {orderedpopupView && (
        <Popup
          extClass="order-pop priceBand-cart-details-pop pop-container-sm"
          headMoreTxt={
            <>
              <div className="order-top"></div>{" "}
            </>
          }
          closebtn={
            <>
              <div className="pop-header-top order-top">
                <div className="head">
                  <h4>
                    {accountPriceband} - {t("customers_txt")}
                  </h4>
                </div>
                <span
                  onClick={() => setorderedPopupView(false)}
                  className="close"
                ></span>
              </div>
            </>
          }
          bodyMoreTxt={
            <>
              <div className="modal-table">
                {loading && (
                  <div className="loading-overlay">
                    <div className="loading-message">{t("loading_txt")}</div>
                  </div>
                )}
                {!loading && (
                  <div className="checkout-table">
                    <div className="table_overflow">
                      <table>
                        <thead>
                          <tr>
                            <td align="left">{t("account_code_txt")}</td>
                            <td align="left">{t("account_name_txt")}</td>
                            <td align="center">{t("status_txt")}</td>
                          </tr>
                        </thead>
                        <tbody>
                          {orderedAccounts.length > 0 &&
                            orderedAccounts.map((item, index) => {
                              return (
                                <tr key={index}>
                                  <td>{item.accountCode}</td>
                                  <td align="left">{item.accountName}</td>
                                  <td align="center">
                                    {item.accountStatus === "active"
                                      ? t("active_txt")
                                      : t("inactive_txt")}
                                  </td>
                                </tr>
                              );
                            })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}
              </div>
            </>
          }
        />
      )}
    </div>
  );
};
